// ../../../component/base/LoadingSpinner.tsx
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

interface LoadingSpinnerProps {
  loading: boolean;
  notFoundMessage?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  loading,
  notFoundMessage = "Nenhuma atribuição encontrada.",
}) => {
  if (loading) {
    return (
      <div className="row mt-3" style={{ margin: 0 }}>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div className="row w-100 mt-3">
      <div className="col-12">
        <p style={{ textAlign: "center" }}>{notFoundMessage}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
